// extracted by mini-css-extract-plugin
export default {"FS900":"#006700","pricePerPortionMessage":"G4f05cc","oldPrice":"G9bfb0f","oldPriceInCheckout":"G3ee71c","newPriceInCheckout":"G1ad97c","priceMessageInCheckout":"Gf49a02"};